/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import ModalWrapper from 'Src/mentorship/components/mentors/userDetailsModal/modalWrapper';
import { getMentorData, sendConnectionRequest, updateConnectionStatus } from 'Src/mentorship/actions';
import { bool, func, instanceOf } from 'prop-types';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import DisplayFormFields from 'Src/common/components/displayFormFields';
import { Button, Form, Spin, notification } from 'antd';
import UserDetails from 'Src/mentorship/components/mentors/userDetailsModal/userDetails';
import ConnectToMentor from 'Src/mentorship/components/mentors/userDetailsModal/connectToMentor';
import { find } from 'lodash';

function MentorDetails({
  closeMentorDetailsModal,
  modalData,
  isOpen,
  toggleRequestSentModal,
  onboardingStatus,
  connectionData,
  setConnectionData,
}) {
  const [mentorData, setMentorData] = useState({});
  const [fieldsXHash, setFieldsXHash] = useState({});
  const [showNote, setShowNote] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const isOnlyMentor = !onboardingStatus?.form_1_data?.is_mentee && onboardingStatus?.form_1_data?.is_mentor;

  function saveHashMapOfFieldsX() {
    const { fields } = window.programDetails.registration_form;
    const result = {};

    if (!fields) return;

    fields.forEach((field) => {
      result[field.id] = field;
    });
    setFieldsXHash(result);
  }

  useEffect(() => {
    setLoading(true);

    getMentorData(modalData.id)
      .then((response) => {
        setMentorData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    saveHashMapOfFieldsX();
  }, []);

  const handleShowNote = () => {
    setShowNote(true);
  };

  const sendRequest = () => {
    form.validateFields().then(() => {
      setSubmitBtnLoading(true);

      const fields = form.getFieldsValue(true);
      const noteObj = fields.note ? { note: fields.note } : {};

      sendConnectionRequest({ mentor: mentorData.id, service: fields.service, ...noteObj })
        .then(() => {
          setSubmitBtnLoading(false);
          setConnectionData({ ...connectionData, connections_available: connectionData.connections_available - 1 });
          toggleRequestSentModal();
          closeMentorDetailsModal();
        })
        .catch(() => {
          setSubmitBtnLoading(false);
        });
    });
  };

  const withdrawRequest = () => {
    setSubmitBtnLoading(true);
    const connectionDetails = find(mentorData.connections, (connection) => connection.mentee === window.userData.id);
    setConnectionData({ ...connectionData, connections_available: connectionData.connections_available + 1 });

    updateConnectionStatus(connectionDetails.id, { status: 6 })
      .then(() => {
        notification.success({
          message: 'Connection request withdrawn',
          description: (
            <p className="arc-p">
              You have
              {' '}
              {connectionData?.connections_available + 1}
              {' '}
              connections remaining.
              <br />
              You can view your connections in the connections tab.
            </p>
          ),
        });

        setSubmitBtnLoading(false);
        closeMentorDetailsModal();
      })
      .catch(() => {
        setSubmitBtnLoading(false);
      });
  };

  return (
    <ModalWrapper isOpen={isOpen} closeMentorDetailsModal={closeMentorDetailsModal}>
      <Choose>
        <When condition={loading}>
          <Spin />
        </When>
        <Otherwise>
          <UserDetails data={modalData} mentorData={mentorData} connectionData={connectionData} />
          <div className="mt20">
            <DisplayFormFields submissionData={mentorData?.form_entry} fieldsXHash={fieldsXHash} itemClassName="mt20" />
          </div>
          <Button type="link" className="view-profile-btn" href={mentorData.profile_url}>
            <I18nCustomFormatter id="view-full-profile" />
          </Button>
          <If condition={!isOnlyMentor}>
            <ConnectToMentor
              mentorData={mentorData}
              connectionData={connectionData}
              showNote={showNote}
              handleShowNote={handleShowNote}
              form={form}
              sendRequest={sendRequest}
              withdrawRequest={withdrawRequest}
              closeModal={closeMentorDetailsModal}
              submitBtnLoading={submitBtnLoading} />
          </If>
        </Otherwise>
      </Choose>
    </ModalWrapper>
  );
}

MentorDetails.propTypes = {
  closeMentorDetailsModal: func.isRequired,
  modalData: instanceOf(Object).isRequired,
  onboardingStatus: instanceOf(Object).isRequired,
  connectionData: instanceOf(Object).isRequired,
  isOpen: bool.isRequired,
  toggleRequestSentModal: func.isRequired,
  setConnectionData: func.isRequired,
};

export default MentorDetails;
